// Общий type-guard — SSOT для `x is Record<string, unknown>`-проверок
// на границах внешних данных (JSONB, JSON.parse, WS).

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}
